var crUtils = (function() {

	return {
		/**
		 * This function translate a param object into a string with get parameters
		 * The param object can contain single value and array
		 * @param  {Object} paramsObject Object to be translated
		 * @return {String} The string containing the get parameters
		 */
		param: function(paramsObject) {
			var paramsRpc = "";
			// add the list of params
			for(var key in paramsObject) {
				if (paramsObject.hasOwnProperty(key)) {
					// if param is an array add every value as param
					if (paramsObject[key].constructor.toString().indexOf('Array') > -1) {
						for(var i = 0; i < paramsObject[key].length; i++) {
							paramsRpc += "&" + key + "=" + paramsObject[key][i];
						}
					} else {
						// param is a single value
						paramsRpc += "&" + key + "=" + paramsObject[key];
					}
				}
			}
			return paramsRpc;
		}
	};
})();
